import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import classes from "./AdminHeaderLink.module.scss";
import chevronDown from "./../../../../assets/icons/chevron-down.svg";
import chevronDownActive from "./../../../../assets/icons/chevron-down-active.svg";
import ChevronDownIcon from "../../../../assets/icons/components/ChevronDownIcon";
import { boxiPrimary } from "../../../../assets/style/colors";
import LogoutIcon from '@mui/icons-material/Logout';

const AdminHeaderLink = ({ disabled, isLogoutButton, path, activeIcon, inactiveIcon, children, dropdownOptions }) => {
  const [isActive, setActive] = useState(false);
  const [isDropdownOptionActive, setDropdownOptionActive] = useState(false);

  return (
    <div>
      <NavLink 
        isActive={(match) => {
          if (!match) {
            setActive(false)
            return false;
          }
          setActive(true)
          return true
        }} 
        activeClassName={classes.active} 
        className={disabled ? classes.disabledLink : isLogoutButton ? classes.logoutLink : classes.link} 
        to={disabled ? '#' : path}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', flexGrow: 1}}>
          <div style={{ display: "flex", alignItems: "center", columnGap: 10 }}>
            {/* <img height={iconHeight} width={iconWidth} src={isActive ? activeIcon : icon} /> */}
            {isActive ? activeIcon : inactiveIcon}
            {isLogoutButton && <LogoutIcon fontSize="15" />}
            {children}
          </div>
          {dropdownOptions && <ChevronDownIcon color={isActive ? boxiPrimary : '#fff'} />}
        </div>
      </NavLink>
      {isActive && <div className={classes.dropdownOptionsWrapper}>
        {dropdownOptions && dropdownOptions.map((option) => {
          return (
            <NavLink
              isActive={(match) => {
                if (!match) {
                  setDropdownOptionActive(false);
                  return false;
                } 
                setDropdownOptionActive(true);
                return true;
              }} 
              activeClassName={classes.dropdownOptionActive} 
              className={classes.dropdownOption} 
              to={option.path}
            >
              {option.name}
            </NavLink>
          )
        })}
      </div>}
    </div>
  );
};

export default AdminHeaderLink;
